// api
import { fetchApi } from '@/api'
import router from '@/router'

// actions
const cafeteriaRequestsAll = (context) => {
  let url = 'cafeteria/requests'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REQUESTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaRequestsForm = (context) => {
  let url = 'cafeteria/requests/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REQUESTS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaRequestsShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'cafeteria/requests/' + obj.id + '/edit'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REQUESTS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const cafeteriaRequestsCreate = (context, payload) => {
  let url = 'cafeteria/requests'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REQUESTS_CREATE', response)
      router.push('/external/request')
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaRequestsUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'admin/users/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('CAFETERIA_REQUESTS_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaRequestsDelete = (context, payload) => {
  let url = 'cafeteria/requests'
  console.log(payload)
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('CAFETERIA_REQUESTS_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

/* const validateCredential = (context, payload) => {
  let url = 'admin/carnets/' + payload + '/validate'
  let data = {}
  console.log(payload)
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('CAFETERIA_REQUESTS_VALIDATE', response)
      router.push('recreate')
    })
    .catch((error) => {
      console.error(error)
    })
} */

export default {
  cafeteriaRequestsAll,
  cafeteriaRequestsForm,
  cafeteriaRequestsShow,
  cafeteriaRequestsCreate,
  cafeteriaRequestsUpdate,
  cafeteriaRequestsDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/cafeteria/requests/actions.js